export const FACEBOOK_URL = "http://www.facebook.de/reisezieldeutschland";
export const INSTAGRAM_URL = "http://www.instagram.com/reisezieldeutschland";
export const REISEZIEL_URL = "http://www.reisezieldeutschland.de";
